const cartCheckoutUrl = (
	`query CartCheckoutUrl($cartId: ID!, $consent: VisitorConsent) @inContext(visitorConsent: $consent) {
		cart(id: $cartId) {
			checkoutUrl
		}
	}`
);

export default cartCheckoutUrl;
